const roles = {
    OWNER: "OWNER", //all access and not allow to access to user dashboard
    ADMIN: "ADMIN", //access to dashboard but not allow to add or remove students and not allow to access to user dashboard
    VIEWER: "VIEWER", // access to dashboard but not view only and not allow to access to user dashboard
    STUDENT: "STUDENT", // access to user dashboard only
};
export default roles;
